import {Reel} from 'com/gongxigames/math/core/game/Reel';
import {ReelConstants} from '@gongxigames/framework/slot/utils';
import {LogicEvents} from '@gongxigames/framework/slot/services/logic/LogicEvents';
import {AnticipatorEvents, AnticipatorView} from '@gongxigames/framework/slot/modules/anticipator';
import {Module, ReelsEvents} from '@gongxigames/framework/slot';

export class AnticipatorModule extends Module<AnticipatorView> {
    public static readonly NAME: symbol = Symbol('AnticipatorModule');

    public static readonly SYMBOLS_AMOUNT_FOR_TRIGGERING_FREESPINS: number = 3;
    public static readonly SOUND_NAME: string = 'hyperspin';

    protected _anticipatedReels: number[] = [];
    protected _isQuickStop = false;

    protected setupStates(): void {}

    protected setupViews(): void {
        this.setView(AnticipatorView.NAME);
    }

    protected setupEvents(): void {
        super.setupEvents();

        this.on(ReelsEvents.REELS_SPINNING_STARTED, this.onReelStartSpin.bind(this));
        this.on(ReelsEvents.REEL_START_STOPPING, this.onReelStopped.bind(this));
        this.on(LogicEvents.SPIN_RESPONSE, this.onSpinResultReceived.bind(this));
        this.on(LogicEvents.FREE_SPIN_RESPONSE, this.onSpinResultReceived.bind(this));
        this.on(ReelsEvents.REELS_QUICKSTOP_STATE_ENTERED, this.onQuickStoppingInitiated.bind(this));

        this.onView(AnticipatorView.STARTED, this.onAnticipationAnimationStarted.bind(this));
    }

    protected onAnticipationAnimationStarted(listenerId: symbol, duration: number): void {
        this.eventManager.emit(AnticipatorEvents.ANIMATION_STARTED, duration);
        this.soundPlayer.play(AnticipatorModule.SOUND_NAME);
    }

    protected onReelStopped(listenerId: symbol, reelIndex: number): void {
        if (this._anticipatedReels.indexOf(reelIndex + 1) !== -1 && !this._isQuickStop) {
            this.view.play(reelIndex + 1);
        }
    }

    protected onReelStartSpin(): void {
        this._isQuickStop = false;
    }

    /**
     * code here works only for certain free spins winning logic:
     * if we're winning free spins if we're receive scatters (symbol 11) on any 3 positions
     */
    protected onSpinResultReceived(): void {
        const stopPositions: number[] = this.logic.spinData.reelPositions;
        const reels: Reel[] = this.logic.getReelSet().getReels();

        this._anticipatedReels = [];

        if (!this.isAutoplaySkip()) {
            this.initAnicipatedReelsList(reels, stopPositions);
        }

        this.eventManager.emit(AnticipatorEvents.ANTICIPATION_REELS_RESULT_RECEIVED, this._anticipatedReels);
    }

    protected isAutoplaySkip(): boolean {
        return this.settings.get('autoplayMode') && this.settings.get('autoplaySkipLongSpins');
    }

    protected initAnicipatedReelsList(reels: Reel[], stopPositions: number[]): void {
        let anticipatedSymbolsFound = 0;

        for (let reelIndex = 0; reelIndex < reels.length; reelIndex++) {
            const stopPosition: number = stopPositions[reelIndex];
            const reel: Reel = reels[reelIndex];

            if (anticipatedSymbolsFound >= (this.getSymbolsAmountForFreeSpins() - 1)) {
                this.addToAnticipatedReelsList(reelIndex);
            }

            for (let rowIndex = 0; rowIndex < ReelConstants.ROW_AMOUNT; rowIndex++) {
                const symbol: number = reel.getSymbol(this.makeNormalizedPosition(reel, stopPosition + rowIndex));

                if (this.isSymbolAnticipated(symbol)) {
                    anticipatedSymbolsFound++;
                }

            }
        }
    }

    protected getSymbolsAmountForFreeSpins(): number {
        return AnticipatorModule.SYMBOLS_AMOUNT_FOR_TRIGGERING_FREESPINS;
    }

    protected makeNormalizedPosition(reel: Reel, position: number): number {
        if (position < 0) {
            return (position % reel.getSymbols().length) + reel.getSymbols().length;
        }

        return position % reel.getSymbols().length;
    }

    protected onQuickStoppingInitiated(): void {
        this._isQuickStop = true;
        this._anticipatedReels = [];
        this.soundPlayer.stop(AnticipatorModule.SOUND_NAME);
        this.view.stopAnticipationAnimation();
    }

    public addToAnticipatedReelsList(reelIndex: number): void {
        if (this._anticipatedReels.indexOf(reelIndex) === -1) {
            this._anticipatedReels.push(reelIndex);
        }
    }

    protected isSymbolAnticipated(symbol: number): boolean {
        return false;
    }
}
